<template>
    <div
        class="transpond_kline_wrap"
        @click.stop.prevent="handleClickKlineDetail"
    >
        <div class="transpond_kline_content">
            <div class="kline_img">
                <img :src="require('@/assets/images/icon_k_line.gif')" />
            </div>
            <div class="kline_detail">
                <h3>{{ msg.share_msg.title }}</h3>
                <div class="user_box">
                    <ul class="user_list">
                        <li v-for="(item, index) in msg.share_msg.join_user" :key="'kline_' + index">
                            <img :src="item.image" />
                        </li>
                    </ul>
                    <p class="user_num">{{ msg.share_msg.join_num }}</p>
                </div>
            </div>
            <div class="kline_challenge">我要挑战</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "kLineCard",
    props: {
        msg: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {

        }
    },
    created() {

    },
    methods: {
        handleClickKlineDetail() {
            this.openNative('k_line_page')
        },
        // 跳转APP页面
        openNative(type) {
            let params = {
                kind: type, // 类型
            };

            switch (type) {
                case "k_line_page": // K线训练营
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native', params)
        },
    }
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.transpond_kline_wrap {
    padding: rem2(10px) rem2(14px) 0;

    .transpond_kline_content {
        height: rem2(70px);
        padding: 0 rem2(12px) 0 rem2(5px);
        background: #f7f7f7;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .kline_img {
            width: rem2(62px);
            height: rem2(62px);
            flex-shrink: 0;

            >img {
                width: 100%;
                height: 100%;
            }
        }

        .kline_detail {
            flex: 1;
            padding-left: rem2(8px);
            width: rem2(170px);

            >h3 {
                font-size: rem2(15px);
                color: #393939;
                margin-bottom: rem2(7px);
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .user_box {
                height: rem2(24px);
                display: flex;
                align-items: center;

                .user_list {
                    height: rem2(24px);
                    // position: relative;
                    display: flex;

                    >li {
                        width: rem2(20px);
                        height: rem2(20px);
                        border: rem2(2px) solid rgba(247, 247, 247, 1);
                        position: relative;
                        top: 0;
                        border-radius: 50%;
                        overflow: hidden;

                        >img {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }

                        &:nth-child(1) {
                            left: 0;
                            z-index: 3;
                        }

                        &:nth-child(2) {
                            left: rem2(-4px);
                            z-index: 2;
                        }

                        &:nth-child(3) {
                            left: rem2(-8px);
                            z-index: 1;
                        }
                    }
                }

                .user_num {
                    color: #939393;
                    font-size: rem2(12px);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }

        .kline_challenge {
            width: rem2(70px);
            height: rem2(28px);
            flex-shrink: 0;

            background: linear-gradient(115deg,
                    rgba(255, 172, 117, 1) 0%,
                    rgba(255, 173, 29, 1) 100%);
            border-radius: rem2(14px);
            font-size: rem2(13px);
            color: #ffffff;
            text-align: center;
            line-height: rem2(28px);
        }
    }
}
</style>